import React, { Component } from 'react';
import { Spin, Select, Button, Tag } from 'antd';
import HighChartsCom from './HighChartsCom';
import RandomDateRange from './RandomDateRange';
import chartConfig from '../../common/chartsConfig';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';

const { Option } = Select;
const yearFormat = 'YYYY';
const monthFormat = 'YYYY-MM';
const dateFormat = 'YYYY-MM-DD';

class MyWork extends Component {
    state = {
        series: [],
        project: [],
        categories: [],
        searchParams: {
            type: 'day',
            projectId: '',
            startDate: moment().subtract(6, 'd').format(dateFormat),
            endDate: moment().format(dateFormat),
        },
        loading: false,
        chartsConfig: {}
    }

    componentDidMount() {
        this.loadData();
        this.loadProject();
        const chartsConfig = JSON.parse(JSON.stringify(chartConfig));
        chartsConfig.exporting.buttons.contextButton.menuItems = [
            'downloadJPEG', 'downloadPDF', 'downloadPNG', 'downloadSVG', 'label'
        ];
        chartsConfig.exporting.menuItemDefinitions.label = {
            onclick: () => {
                const { searchParams } = this.state;
                const { type } = searchParams;

                let url = API_URL.home.exportManHourMyWorkByDate;
                if (type == 'week') {
                    url = API_URL.home.exportManHourMyWorkByWeek;
                } else if (type == 'year') {
                    url = API_URL.home.exportManHourMyWorkByMonth;
                }
                ExportUtil.export({ ...searchParams }, null, url);
            },
            text: '导出Excel'
        }
        this.setState({ chartsConfig });
    }

    loadData = () => {
        this.setState({ loading: true });
        const { searchParams } = this.state;
        const { type } = searchParams;

        let url = API_URL.home.queryManHourMyWorkByDate;
        if (type === 'week') {
            url = API_URL.home.queryManHourMyWorkByWeek;
        } else if (type === 'year') {
            url = API_URL.home.queryManHourMyWorkByMonth;
        }

        const options = {
            method: 'POST',
            url: url,
            data: {
                ...searchParams,
            },
            dateType: 'json',
            doneResult: data => {
                let categories = [];
                let series = [];

                categories = type === 'week' ? data.data.map(d => `${d.weekNum}周`) : type === 'year' ? data.data.map(d => `${d.yearNum}-${d.monthNum}月`) : data.data.map(d => moment(d.manHourDate).format(dateFormat));
                series = [{
                    data: data.data.map(d => d.duration * 1),
                    name: '工时'
                }];

                this.setState({
                    series,
                    categories,
                    loading: false,
                });
            }
        };
        $.sendRequest(options);
    }

    loadProject = () => {
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryUserInvestigationList2,
            data: {
                offset: 1,
                limit: 15,
                isFinish: 'a',
            },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                const { enterpriseWorkCategories } = data || {};
                this.setState({
                    project: enterpriseWorkCategories || [],
                });
            }
        };
        $.sendRequest(options);
    }

    handleSelectChange = (value, key) => {
        const { project, searchParams } = this.state;
        searchParams[key] = value;
        if (key === 'type') {
            if (value === 'day' || value === 'free') {
                searchParams.startDate = moment().subtract(6, 'd').format(dateFormat);
                searchParams.endDate = moment().format(dateFormat);
                searchParams.year = '';
            } else if (value === 'week') {
                searchParams.startDate = moment().week() - 4;
                searchParams.endDate = moment().week();
                searchParams.year = moment().format(yearFormat);
            } else if (value === 'year') {
                searchParams.startDate = moment().subtract(6, 'M').format(monthFormat);
                searchParams.endDate = moment().add(1, 'M').format(monthFormat);
                searchParams.year = '';
            }
        } else if (key === 'projectId') {
            const option = project.find(i => i.enterpriseWorkCategoryId == value);
            const { isInves, invesId, enterpriseWorkCategoryId } = option || {};
            searchParams.investigationId = isInves ? invesId : '';
            searchParams.enterpriseWorkCategoryId = isInves ? '' : enterpriseWorkCategoryId;
        }
        this.setState({ searchParams }, () => {
            if (value === 'free') {
                this.dateRef.show(searchParams);
            }
        });
    }

    changeFreeDate = (params) => {
        this.setState(state => {
            return {
                searchParams: {
                    ...state.searchParams,
                    ...params,
                }
            }
        });
    }

    render() {
        const { series, project, categories, loading, searchParams } = this.state;
        const { type, projectId, startDate, endDate } = searchParams;
        const projectOptions = project.map(d => <Option key={String(d.enterpriseWorkCategoryId)}>{d.enterpriseWorkCategoryName}</Option>);
        return (
            <div className="flexItem outer myFocus" style={{ minHeight: 500 }}>
                <Spin spinning={loading}>
                    <div className='modTitle'>我的工作</div>
                    <div className='tit'>近期工时情况</div>
                    <div style={{ marginBottom: 30 }}>
                        <Select
                            style={{ width: 100, marginRight: 10 }}
                            onChange={value => this.handleSelectChange(value, 'type')}
                            placeholder='近七天'
                            value={type}
                        >
                            <Option value="day">近七天</Option>
                            <Option value="week">近四周</Option>
                            <Option value="year">近半年</Option>
                            <Option value="free">自定义</Option>
                        </Select >
                        <Select
                            style={{ width: 200, marginRight: 10 }}
                            onChange={value => this.handleSelectChange(value, 'projectId')}
                            placeholder='请选择'
                            value={projectId}
                        >
                            <Option value="">所有项目</Option>
                            {projectOptions}
                        </Select >
                        <Button type='primary' onClick={this.loadData}>统计</Button>
                        <div style={{ display: type == 'free' ? 'block' : 'none', marginTop: 8 }}><Tag color="orange">自定义时间段：{startDate} 至 {endDate}</Tag></div>
                    </div>
                    <div style={{ marginTop: 20 }}><HighChartsCom series={series} categories={categories} chartsConfig={this.state.chartsConfig} /></div>
                    <RandomDateRange ref={el => this.dateRef = el} changeFreeDate={this.changeFreeDate} />
                </Spin>
            </div>
        );
    }
}

export default MyWork;


// WEBPACK FOOTER //
// ./src/components/homePage/myFocus/MyWork.js